import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "appointmentSelectSpeciality" },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-center justify-space-between",
          attrs: { "data-qa": "appointment_selected_speciality_card" },
        },
        [
          _c("div", { staticClass: "pr-4" }, [
            _c(
              "div",
              {
                staticClass: "text-body-1 text--text",
                attrs: {
                  "data-qa": "appointment_selected_speciality_card_name",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_setup.selectSpecialityTitle) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text-body-2 text-secondary--text",
                attrs: {
                  "data-qa": "appointment_selected_speciality_card_description",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_setup.selectSpecialitySubtitle) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _setup.formattedWorkplaceList.length > 1
            ? _c(
                VBtn,
                {
                  attrs: {
                    "data-qa": "appointment_selected_speciality_card_icon",
                    color: "icon-secondary--text",
                    height: "32",
                    width: "32",
                    icon: "",
                  },
                  on: {
                    click: function ($event) {
                      _setup.isModalVisible = true
                    },
                  },
                },
                [_c("span", { staticClass: "ui-icon-pen" })]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        _setup.isMobile ? _setup.CoreBottomSheet : _setup.CoreDialog,
        _vm._b(
          {
            tag: "component",
            attrs: {
              title: "Выберите специальность врача",
              persistent: !_setup.selectedWorkplace,
              eager: "",
            },
            scopedSlots: _vm._u(
              [
                _setup.selectedWorkplace
                  ? {
                      key: "prependBtn",
                      fn: function ({ btnProps }) {
                        return [
                          _c(
                            VBtn,
                            _vm._b(
                              {
                                on: {
                                  click: function ($event) {
                                    _setup.isModalVisible = false
                                  },
                                },
                              },
                              "v-btn",
                              btnProps,
                              false
                            ),
                            [
                              _c("span", {
                                staticClass: "ui-icon-close-not-a-circle",
                              }),
                            ]
                          ),
                        ]
                      },
                    }
                  : null,
                {
                  key: "default",
                  fn: function ({ xSpaceClass, counterXSpaceClass }) {
                    return [
                      _setup.nearestSlotsStore.isPending
                        ? _c(_setup.ListSkeleton, {
                            attrs: {
                              "data-qa": "appointment_patient_list_skeleton",
                            },
                          })
                        : _c(
                            VList,
                            {
                              class: counterXSpaceClass,
                              attrs: {
                                "data-qa": "appointment_speciality_list",
                              },
                            },
                            _vm._l(
                              _setup.formattedWorkplaceList,
                              function (workplace) {
                                return _c(
                                  VListItem,
                                  {
                                    key: workplace.id,
                                    class: xSpaceClass,
                                    attrs: {
                                      "data-qa":
                                        "appointment_speciality_list_speciality",
                                      disabled: workplace.isDisabledWorkplace,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleClickWorkplaceItem(
                                          workplace
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      VListItemContent,
                                      [
                                        _c(
                                          VListItemTitle,
                                          { staticClass: "d-flex align-end" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-body-1",
                                                attrs: {
                                                  "data-qa":
                                                    "appointment_speciality_list_speciality_name",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      workplace.speciality.name
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          VListItemSubtitle,
                                          {
                                            staticClass:
                                              "text-body-2 text-break mt-1",
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-qa":
                                                        "appointment_speciality_list_speciality_price",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(workplace.price)
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                workplace.specialityAges
                                                  ? [
                                                      _vm._v(
                                                        "\n                  • "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            "data-qa":
                                                              "appointment_speciality_list_speciality_ages",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              workplace.specialityAges
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            workplace.warningDate
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-body-2 text-warning--text mt-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                На выбранное время запись недоступна.\n                "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " Ближайшее к нему – "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-qa":
                                                            "appointment_speciality_list_speciality_warning_date",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            workplace.warningDate
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      VListItemIcon,
                                      {
                                        staticClass:
                                          "align-self-center my-auto",
                                      },
                                      [
                                        _c(
                                          VIcon,
                                          {
                                            attrs: { color: "text-secondary" },
                                          },
                                          [
                                            _vm._v(
                                              "\n              ui-icon-arrow-right\n            "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
            model: {
              value: _setup.isModalVisible,
              callback: function ($$v) {
                _setup.isModalVisible = $$v
              },
              expression: "isModalVisible",
            },
          },
          "component",
          _setup.isMobile
            ? {
                minHeight: "65dvh",
              }
            : {
                size: "lg",
                minHeight: 496,
              },
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }